// import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function getNestedValue(obj, key) {
  if (!key || typeof key !== "string") {
    console.error("Clave no válida:", key);
    return undefined;
  }
  return key.split(".").reduce((o, i) => o?.[i], obj);
}

/**
 * Exporta los datos a un archivo Excel con las columnas seleccionadas y aplica estilos
 * @param {Array} data - Datos a exportar (debe ser un array de objetos)
 * @param {Array} selectedColumns - Columnas que se deben exportar
 * @param {string} fileName - Nombre del archivo de salida
 */
export const exportToExcel = async (data, selectedColumns, fileName = "tabla_exportada.xlsx") => {
  const XLSX = await import("xlsx");
  const filteredSelectedColumns = selectedColumns.filter(Boolean);

  if (!data?.length) {
    console.warn("No hay datos para exportar.");
    return;
  }

  if (!filteredSelectedColumns?.length) {
    console.warn("No se han seleccionado columnas.");
    return;
  }

  const columnKeys = filteredSelectedColumns.map((col) => col.accessorKey);
  const filteredData = data.map((row) => Object.fromEntries(columnKeys.map((key) => [key, getNestedValue(row, key)])));

  const ws = XLSX.utils.json_to_sheet(filteredData);
  const headers = filteredSelectedColumns.map((col) => col.header ?? col.accessorKey);

  headers.forEach((header, index) => {
    const cellRef = XLSX.utils.encode_cell({ c: index, r: 0 });
    ws[cellRef] = { v: header, t: "s" };
  });

  ws["!cols"] = headers.map((col) => ({ wch: col.length + 10 }));

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Datos");

  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const dataBlob = new Blob([excelBuffer], { type: "application/octet-stream" });

  saveAs(dataBlob, fileName);
};
